import { FC } from 'react';

import { useTranslations } from 'context/translations';
import {
  LandingPageImageKeys,
  LandingPageLinkKeys,
  LandingPageTextKeys,
} from 'service';
import { Button } from 'components';

import styles from './JoinRevenueProgramBlock.module.css';

export const JoinRevenueProgramBlock: FC = () => {
  const { t, image, link } = useTranslations();
  return (
    <div>
      <div className={styles.container}>
        <h1>{t(LandingPageTextKeys.JoinBlockTitle)}</h1>
        <div className={styles.description}>
          {t(LandingPageTextKeys.JoinBlockDescription)}
        </div>
        <Button
          size="large"
          view="black"
          className={styles.button}
          to={link(LandingPageLinkKeys.AffiliatesLink)}
        >
          {t(LandingPageTextKeys.JoinBlockButton)}
        </Button>
      </div>
      <div
        className={styles.background}
        style={{
          backgroundPosition: '0% 42%',
          backgroundSize: '900px',
          backgroundImage: `url(${image(
            LandingPageImageKeys.JoinBlockBackground,
            { h: 0 },
          )})`,
        }}
      />
    </div>
  );
};
